module.exports = __webpack_public_path__ + "static/media/right hip pain.78feda21.png";